// extracted by mini-css-extract-plugin
export default {"wrap":"DO-z","fullWidth":"EO-z","hideOnDesktop":"FO-z","content":"GO-z","hasOpenedNav":"HO-z","crumbsList":"IO-z","dropdownsWrap":"JO-z"};